import * as React from 'react';
import * as gls from '../../ap/layout/gls';
import * as typestyle from 'typestyle';
import { colors, maxPageContentWidth } from '../../ap/base/styles';
import * as csx from 'csstips';
import { FooterAnchor } from '../../ap/base/anchor';
import { APLogo } from '../../ap/base/icons';


export namespace FooterStyles {
  export const footerHeight = 60;

  export const footerClassName = typestyle.style(
    csx.content,
    {
      backgroundColor: colors.coolGrey4,
      height: `${footerHeight}px`,
      borderTop: `1px solid ${colors.warmGrey3}`
    }
  );

  export const footerContentClassName = typestyle.style(
    csx.padding(22, 20),
    csx.flex,
    csx.horizontal,
    csx.center,
    {
      margin: '0 auto',
      maxWidth: `${maxPageContentWidth}px`,
    }
  );
}


export interface FooterLink {
  text: string,
  href: string,
  subSection: any
}
export interface FooterProps {
  links: FooterLink[]
}
/**
 * The common footer for the app
 */
export const Footer = (props: FooterProps) => {
  return (
    <div data-comment="Footer" className={FooterStyles.footerClassName}>
      <div className={FooterStyles.footerContentClassName}>
        <gls.ContentHorizontalMargined margin={20}>
          {props.links.map((link,i) => {
            return <FooterAnchor key={i} href={link.href} target="_blank" onClick={link.subSection}><span>{link.text}</span></FooterAnchor>;
          })}
        </gls.ContentHorizontalMargined>
      </div>
    </div>
  );
}
